import documentsService from '@/services/documents'

export default {
  methods: {
    async redirectToAso(id, pathParam) {
      try {
        this.showLoading()
        const url = await documentsService.getUrlAso(id, pathParam)
        console.log(url)
        window.open(url, '_blank')
      } finally {
        this.hideLoading()
      }
    },
    async redirectToGuia(id, pathParam) {
      try {
        const url = await documentsService.getUrlGuia(id, pathParam)
        console.log(url)
        window.open(url, '_blank')
      } finally {
        this.hideLoading()
      }
    }
  }
}
